import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { ConnectedRouter } from 'connected-react-router';
import { useSelector, useDispatch } from 'react-redux';
import PrivateRoute from './routes/PrivateRoutes';


// Styles
// CoreUI Icons Set
import '@coreui/icons/css/coreui-icons.min.css';
// Import Flag Icons Set
import "../node_modules/flag-icons/css/flag-icons.min.css";
// Import Font Awesome Icons Set
import 'font-awesome/css/font-awesome.min.css';
// Import Simple Line Icons Set
import 'simple-line-icons/css/simple-line-icons.css';
// Import Main styles for this application
import './scss/style.css';
import 'react-bootstrap-table/dist/react-bootstrap-table.min.css';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import './scss/react-checkbox-tree.css';

// Containers
import { DefaultLayout } from './containers';
// Pages
import { Login, Page404 } from './views';// Las views vienen del export de index.jsx dentro de views
import ImpersonateScreen from './views/Pages/Login/Impersonate/ImpersonateScreen';
import MfaScreen from './views/Pages/Login/MfaScreen';
import { getIsAuth } from './redux/actions/authActions';

const App = ({ history }) => {
  const dispatch = useDispatch();
  const { auth } = useSelector((store) => store.auth);
  
  useEffect(() => {
    //console.log('call getIsAuth()');
    dispatch(getIsAuth());
  }, [auth.authenticated]);

  return (
    <ConnectedRouter history={history}>
      <Router>
        <Switch>
          <Route exact path="/login" component={Login} isAuth={!!auth.authenticated} />
          <Route exact path="/page404" component={Page404} />
          <Route exact path="/mfa" component={MfaScreen} />
          {/* TODO QUITAR ESTO: */}
          <PrivateRoute exact path="/impersonate" component={ImpersonateScreen} isAuth={!!auth.authenticated && !!auth.canLogin} />
          {/* End QUITAR ESTO! */}
          <PrivateRoute path="/" component={DefaultLayout} isAuth={!!auth.authenticated} />
        </Switch>
      </Router>
    </ConnectedRouter>
  );
};

export default App;
